import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Login from './components/Auth/Login';
import Gateway from './components/Auth/Gateway';
import SMLoginError from './components/Auth/SMLoginError';
import EmailVerification from './components/Auth/EmailVerification';
import Logout from './components/Auth/Logout';
import DeletedCues from './components/Cuesheets/DeletedCues';
import AmendmentHistory from './components/Cuesheets/AmendmentHistory';
import CueHistory from './components/Cues/CueHistory';
import NonLinearForm from './components/NonLinear/NonLinearForm';
import Verify2FA from './components/Auth/Verification2FA';
import UserProfile from './components/User/UserProfile';

export default () => (
    <Layout>
        <Route exact path='/Login' component={Login} />
        <Route path='/LoginError' component={SMLoginError} />
        <Route path='/Gateway' component={Gateway} />
        <Route path='/EmailVerification/:guid?' component={EmailVerification} />
        <Route path='/Verify2FA' component={Verify2FA} />
        <Route path='/Logout' component={Logout} />
        <Route path='/NonLinearForm/:programmeId' component={NonLinearForm} />
        <Route path='/UserProfile' component={UserProfile} />
        <Route path='/DeletedCues/:programmeId' component={DeletedCues} />
        <Route path='/AmendmentHistory/:programmeId' component={AmendmentHistory} />
        <Route path='/CueHistory/:programmeId/:cueId' component={CueHistory} />
    </Layout>
);


// WEBPACK FOOTER //
// ./src/App.js